import Header from "components/layout/Header";
import { Alert, Button, Col, Typography } from "antd";
import Table from "components/data/Table";
import { FormattedMessage } from "react-intl";

import {
  useEventOccurrenceFilter,
  useExportOrders,
  useOrderColumns,
  useOrderList,
} from "./hooks";

const OrderList = () => {
  const { columns } = useOrderColumns();
  const { alert, filters, isValid } = useEventOccurrenceFilter();
  const { exportOrders, loading: exporting } = useExportOrders(filters);
  const { dataSource, loading, pagination, onChange } = useOrderList(
    filters,
    !isValid
  );

  return (
    <>
      <Header>
        <Col>
          <Typography.Title>
            <FormattedMessage defaultMessage="Orders" />
          </Typography.Title>
        </Col>
        <Col>
          <Button
            type="primary"
            block
            onClick={exportOrders}
            loading={exporting}
            disabled={!isValid}
          >
            <FormattedMessage defaultMessage="Export" />
          </Button>
        </Col>
      </Header>
      {alert && <Alert {...alert} />}
      <Table
        rowKey="id"
        {...{ dataSource, pagination, columns, loading, onChange }}
      />
    </>
  );
};

export default OrderList;
